import { render, staticRenderFns } from "./ClassFilter.vue?vue&type=template&id=1b779102&"
import script from "./ClassFilter.vue?vue&type=script&lang=js&"
export * from "./ClassFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports